import { render, staticRenderFns } from "./TemplateListagemDocumentosVazia.vue?vue&type=template&id=3b46739a"
import script from "./TemplateListagemDocumentosVazia.vue?vue&type=script&lang=js"
export * from "./TemplateListagemDocumentosVazia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports